import { type ReactNode } from 'react';
import { MobileMenuContext } from './MobileMenuContextDefinition';

interface MobileMenuContextValue {
  pdfFile?: File | null;
  isTopSectionExpanded: boolean;
  onToggleTopSection: () => void;
}

interface MobileMenuProviderProps extends MobileMenuContextValue {
  children: ReactNode;
}

export function MobileMenuProvider({ children, ...props }: MobileMenuProviderProps) {
  return (
    <MobileMenuContext.Provider value={props}>
      {children}
    </MobileMenuContext.Provider>
  );
}